// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isSegmentCohortResult = objectOf({
  segment_cohorts: arrayOf(
    objectOf({
      id: string,
      name: string,
      count: number,
      count_operator: string,
      y_days: number,
      last_processed: string,
    })
  ),
});
